/**
 * @fileoverview POST handler for the "/engagement/api/segment_cohorts/:segment_cohort_id/refresh" endpoint
 */
import fetch from "@lib/fetch";

import { engagementApiSegmentCohortsIdRefresh } from "./constants";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

export const refreshSegmentCohort = reactQueryMutationAdapter(
  engagementApiSegmentCohortsIdRefresh,
  (segmentCohortId: string): Promise<void> => {
    return fetch(`/engagement/api/segment_cohorts/${segmentCohortId}/refresh`, "POST", {}, {});
  }
);
